import { render } from "./ButtonShare.vue?vue&type=template&id=5f99ccea&scoped=true&ts=true"
import script from "./ButtonShare.vue?vue&type=script&lang=ts"
export * from "./ButtonShare.vue?vue&type=script&lang=ts"

import "./ButtonShare.vue?vue&type=style&index=0&id=5f99ccea&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f99ccea"]])

export default __exports__